// extracted by mini-css-extract-plugin
export default {"infoMain":"#0058e9","successMain":"#37b400","errorMain":"#f31700","warningMain":"#ffc000"};